import { RICH_TEXT_OPTIONS } from 'consts/contentful';
import { NavBanner } from './NavBanner';
import type { IconName } from '@curology/ui-components-web/react/Icon/DynamicIcon';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { NavBannerEntry } from 'schema';
import { ContentfulModal } from 'components/global/modal/ContentfulModal';
import { SmartImage } from 'components/global/SmartImage';
import { contentfulModalStyles } from 'components/global/modal/ContentfulModal.style';
import {
  useHairRxLandingPageRoute,
  useHairRxPromoVariant,
} from 'utils/hooks/useHairPromoVariation';

export const formatBannerProps = ({
  backgroundColor,
  badgeImage,
  bannerPosition,
  body,
  hideIfVanityBannerIsPresent,
  iconName,
  modal,
  textColor,
  ...props
}: NavBannerEntry) => {
  const chiaWelcomeOfferVariant = useHairRxPromoVariant();
  const isHairRxLandingPage = useHairRxLandingPageRoute();

  return {
    ...props,
    iconName: iconName as IconName,
    backgroundColor,
    text:
      isHairRxLandingPage && chiaWelcomeOfferVariant ? (
        <strong
          dangerouslySetInnerHTML={{
            __html: chiaWelcomeOfferVariant.bannerText + '*',
          }}
        ></strong>
      ) : (
        documentToReactComponents(body, RICH_TEXT_OPTIONS)
      ),
    textColor,
    aboveNavigation: bannerPosition,
    hideIfVanity: hideIfVanityBannerIsPresent,
    modalProps: modal
      ? {
          ...modal,
          styles: () => contentfulModalStyles(modal as any),
          children: <ContentfulModal {...(modal as any)} />,
        }
      : undefined,
    badge: badgeImage ? <SmartImage {...badgeImage} /> : null,
  };
};

export const ContentfulNavBanner = (props: NavBannerEntry) => {
  return <NavBanner {...formatBannerProps(props)} />;
};
